import { cloneDeep, get, set } from 'lodash';
import React from 'react';
import { checkIsNumber } from '../../../Components/helper';
import { usePlanningBottomupState } from '../Context/index';
import useMdCalculationHooks from '../Hooks/MdHooks';
import { mdPath } from '../TablesFieldPath';

export function MDTable() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedLevel, selectedDisplayColumn } = planningBottomup;
  const level = selectedLevel?.level;
  const { calculateMd } = useMdCalculationHooks();
  const mdFields = [
    {
      keyName: 'mdSalesUnits',
      name: 'MD Sales Units',
    },
    {
      keyName: 'markDown',
      name: 'MD%',
    },
    // {
    //   keyName: "mdSalesValue",
    //   name: "MD Sales Value",
    // },
    // {
    //   keyName: "mdSlsMix",
    //   name: "MD Sls Mix %",
    // },
  ];

  const handleChange = async (text, path, index) => {
    const copyState = cloneDeep(planningBottomProducts);
    set(copyState, path, text);
    const currenObj1 = get(copyState, index);
    copyState[index] = await calculateMd(currenObj1);
    setPlanningBottomup((prevState) => ({
      ...prevState,
      planningBottomProducts: copyState,
    }));
  };
  const includeLevel = [6];

  const isTableVisible = mdFields.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {mdFields?.map((mdFielsItem, i) => {
              const isVisible = checkVisibleBottomUp(mdFielsItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{mdFielsItem.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {mdFields?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible &&
                    (tdItem.keyName === 'markDown' ? (
                      <td key={iTD}>
                        {level === 6 ? (
                          <div className="d-flex align-items-center">
                            {' '}
                            <input
                              type="text"
                              className="form-control text-bordered"
                              onChange={(e) => {
                                if (checkIsNumber(e.target.value)) {
                                  handleChange(e.target.value, mdPath(iParent, tdItem?.keyName).MD_PERCENTAGE, iParent);
                                }
                              }}
                              value={trItem?.markDown?.value}
                              disabled={!includeLevel.includes(level) || !planningBottomup?.addEditBottomAccess}
                            />
                            <span className="ml-1">%</span>
                          </div>
                        ) : (
                          `${trItem?.markDown?.value || 0}%`
                        )}
                      </td>
                    ) : (
                      <td key={iTD} className="text-right">
                        {(trItem?.length > 0 && trItem[tdItem.keyName]) || 0}
                        {tdItem.keyName === 'mdSlsMix' && '%'}
                      </td>
                    ))
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default MDTable;
